import { motion } from "framer-motion";
import { useQuote } from "./Header";
import { SITE } from "../../lib/config";

export default function CTABand() {
  const openQuote = useQuote();
  return (
    <section className="relative py-24 bg-[#1D6B2A] overflow-hidden grain" data-testid="cta-band">
      <div className="absolute -right-20 -top-20 w-80 h-80 rounded-full bg-[#4CAF50]/30 blur-3xl" />
      <div className="absolute -left-10 -bottom-20 w-72 h-72 rounded-full bg-[#FDCD00]/20 blur-3xl" />
      <div className="max-w-5xl mx-auto px-5 md:px-10 relative z-10 text-center">
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="font-head text-4xl md:text-6xl font-medium tracking-tight text-white"
        >
          Ready to package your brand better?
        </motion.h2>
        <p className="text-white/70 text-lg mt-5 max-w-2xl mx-auto">
          Get tailored bulk pricing on 200+ product lines. Fast quotes, reliable supply,
          pan-India delivery.
        </p>
        <div className="mt-9 flex flex-wrap gap-4 justify-center">
          <button
            onClick={() => openQuote()}
            data-testid="cta-quote-btn"
            className="bg-[#FDCD00] text-[#0A1C0E] rounded-full px-9 py-4 font-semibold hover:bg-[#e5ba00] transition-colors"
          >
            Request a Quote
          </button>
          <a
            href={`https://wa.me/${SITE.whatsapp}`}
            target="_blank"
            rel="noopener noreferrer"
            className="bg-white/10 border border-white/25 text-white rounded-full px-9 py-4 font-semibold hover:bg-white/20 transition-colors"
          >
            Chat on WhatsApp
          </a>
        </div>
      </div>
    </section>
  );
}
